import downloadS3File from '@/utils/downloadS3File';

import { getType } from 'typesafe-actions';

import {
  runDealContingentActions,
  saveUserWidgetDealContingentActions,
} from './actions';
import { DealContingentActionType, DealContingentState } from './types';

const initialDealContingentState: DealContingentState = {
  saveInputs: {
    loading: false,
    error: null,
  },
  run: {
    loading: false,
    error: null,
    result: null,
  },
};

const dealContingentReducer = (
  state: DealContingentState = initialDealContingentState,
  action: DealContingentActionType,
): DealContingentState => {
  switch (action.type) {
    case getType(saveUserWidgetDealContingentActions.request):
      return {
        ...state,
        saveInputs: {
          loading: true,
          error: null,
        },
      };

    case getType(saveUserWidgetDealContingentActions.success):
      return {
        ...state,
        saveInputs: {
          loading: false,
          error: null,
        },
      };

    case getType(saveUserWidgetDealContingentActions.failure):
      return {
        ...state,
        saveInputs: {
          loading: false,
          error: action.payload,
        },
      };

    case getType(runDealContingentActions.request):
      return {
        ...state,
        run: {
          ...state.run,
          loading: true,
          error: null,
        },
      };

    case getType(runDealContingentActions.success): {
      const result = action.payload;
      const { file_name, file_s3_url } = result.data;
      if (file_s3_url && file_name) {
        downloadS3File(file_s3_url, file_name);
      }

      return {
        ...state,
        run: { loading: false, error: null, result: result },
      };
    }

    case getType(runDealContingentActions.failure):
      return {
        ...state,
        run: {
          loading: false,
          error: action.payload,
          result: null,
        },
      };

    default:
      return state;
  }
};

export default dealContingentReducer;
